import React, { ReactNode } from 'react';
import './Pill.scss';

export const Pill = (props: { children: ReactNode, className?: string }): React.JSX.Element => {
  return (
    <div className={`pill ${props.className || ''}`}>
      { props.children }
    </div>
  )

}